import React from "react";
import styles from "./styles.module.scss";
import { RedirectArrowWhite, RedirectArrowBlack } from "assets";
import { Link } from "react-router-dom";

interface ButtonProps {
	text: string;
	linkTo?: any;
	className?: any;
	blank?: boolean;
	black?: boolean;
	onClick?: any;
	[key: string]: any;
}

const Button: React.FC<ButtonProps> = ({
	text,
	linkTo,
	blank = false,
	className,
	black,
	onClick,
	...rest
}) => {
	const link = blank ? "_blank" : "_self";

	if (!linkTo && rest["data-be-url"]) {
		const handleImmersiveOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
			const bookingUrl = rest["data-be-url"];
			if (bookingUrl && typeof window !== "undefined") {
				window.dispatchEvent(
					new CustomEvent("open-immersive-experience", {
						detail: { url: bookingUrl },
					})
				);
			}
			if (onClick) {
				onClick(event);
			}
		};

		return (
			<button
				className={
					black
						? `row ${styles.buttonLink} ${className} ${styles.black}`
						: `row ${styles.buttonLink} ${className} ${styles.white}`
				}
				onClick={handleImmersiveOpen}
				{...rest}
			>
				<span className={styles.buttonLink__text}>{text}</span>{" "}
				<RedirectArrowWhite id="white" className={styles.redirectWhite} />
				<RedirectArrowBlack id="black" className={`${styles.redirectBlack}`} />
			</button>
		);
	}

	return (
		<>
			<Link
				to={linkTo || "#"}
				className={
					black
						? `row ${styles.buttonLink} ${className} ${styles.black}`
						: `row ${styles.buttonLink} ${className} ${styles.white}`
				}
				id="target"
				onClick={onClick}
				target={link}
				{...rest}
			>
				<span className={styles.buttonLink__text}>{text}</span>{" "}
				<RedirectArrowWhite id="white" className={styles.redirectWhite} />
				<RedirectArrowBlack id="black" className={`${styles.redirectBlack}`} />
			</Link>
		</>
	);
};

export { Button };
